import SectionHeading from '@/components/base/SectionHeading';
import ArticleCard from '@/components/base/ArticleCard';
import { getAllArticles, getArticlesByCategory, buildCategoryPath } from '@/utils/articles';

export default function EditorsPick() {
  const picks = getAllArticles().filter((item) => item.featured || item.hot).slice(0, 2);
  const submissions = getArticlesByCategory('suran-tougao').slice(0, 3);

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14" aria-label="编辑推荐与素人投稿">
      <SectionHeading
        eyebrow="EDITOR'S PICK"
        title="编辑推荐 · 值得细看的两篇"
        description="从当天更新的爆料里，挑出信息更完整、讨论更有价值的两个事件。"
      />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {picks.map((article) => (
          <ArticleCard key={article.id} article={article} variant="wide" />
        ))}
      </div>

      <div className="mt-12 rounded-2xl bg-secondary-50 p-5 md:p-8">
        <SectionHeading
          eyebrow="READER STORIES"
          title="素人投稿精选"
          description="来自普通网友的第一人称讲述，没有滤镜，也不站队。"
          actionLabel="查看全部投稿"
          actionTo={buildCategoryPath('suran-tougao')}
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {submissions.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}